/**
 * A link that displays the departure time of a detection.
 */
import { Link } from 'react-router-dom';
import dateFormat from 'dateformat';

import type { Location } from '../../types/Location';

export default function ArrivalTimeLinkLocal({
  utcTime,
  location,
  setDate,
  handleClick,
  setIsLive,
}: {
  utcTime: string;
  location: Location;
  setDate?: (date: Date) => void;
  handleClick?: () => void;
  setIsLive?: (isLive: boolean) => void;
}): JSX.Element {
  // Unpack the date.
  const localDate = utcTime;
  const valueDate = new Date(localDate.valueOf());
  const formattedDate = Intl.DateTimeFormat('en-US', {
    dateStyle: 'medium', // Can be 'short', 'medium', 'long', or 'full'
    timeStyle: 'medium', // Can be 'short', 'medium', 'long', or 'full'
  }).format(new Date(localDate));
  // Create the query parameters for the link.
  const params = {
    dt:
      dateFormat(valueDate, 'yyyy-mm-dd') +
      'T' +
      dateFormat(valueDate, 'HH:MM'),
    lid: location.id.toString(),
  };
  const urlSearchParams = new URLSearchParams(params);
  const url = '/cameras?' + urlSearchParams.toString();
  return (
    <Link
      className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600"
      to={url}
      onClick={() => {
        if (setIsLive !== undefined) setIsLive(false);
        if (setDate !== undefined) setDate(valueDate);
        if (handleClick !== undefined) handleClick();
      }}
    >
      {formattedDate}
    </Link>
  );
}
